(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('RootCauseAnalysisFactorDialogController', RootCauseAnalysisFactorDialogController);

    RootCauseAnalysisFactorDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RootCauseAnalysisFactor', 'Company'];

    function RootCauseAnalysisFactorDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RootCauseAnalysisFactor, Company) {
        var vm = this;

        vm.rootCauseAnalysisFactor = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.rootCauseAnalysisFactor.id !== null) {
                RootCauseAnalysisFactor.update(vm.rootCauseAnalysisFactor, onSaveSuccess, onSaveError);
            } else {
                RootCauseAnalysisFactor.save(vm.rootCauseAnalysisFactor, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('abcQualityMatchApp:rootCauseAnalysisFactorUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
